module.exports = __webpack_public_path__ + "static/turtle-creek-house17-056d8ca072ed5099a75677425d00b934.jpg";